/**
 * Group/Line Detail Page
 */

import { Tags } from 'lucide-react'
import { CatalogDetailPage } from './CatalogDetailPage'
import { useTranslation } from '@/hooks/useTranslation'

export function GroupDetailPage() {
  const { t } = useTranslation()

  return (
    <CatalogDetailPage
      config={{
        endpoint: 'groups',
        basePath: '/groups',
        title: t('catalogs.groups'),
        editLabel: t('catalogs.editGroup'),
        icon: Tags,
        fields: [
          { key: 'code', label: t('articles.code') },
          { key: 'description', label: t('articles.description') },
        ],
      }}
    />
  )
}
